import { DatePickerDate } from '../types';

export default function getSelectedDates({
  range,
  date,
  startDate,
  endDate,
}: {
  range?: boolean;
  date?: DatePickerDate | null;
  startDate?: DatePickerDate | null;
  endDate?: DatePickerDate | null;
}) {
  let dates;

  if (range) {
    dates = [startDate ?? null, endDate ?? null] as [
      DatePickerDate | null,
      DatePickerDate | null,
    ];
  } else {
    dates = date ? [date] : null;
  }

  return dates;
}
